<template lang="html">
  	<div id="page__stocks" class="center-panel">
		<md-content md-theme="white" v-bind:loading="progress">
			<sort-table
				v-bind:columns="tableColumns" v-model="stocks" @refresh="getStocks"
				v-bind:per-page="perPage" v-bind:total="stocksAmount" table-id="stocks"
				v-on:create="addStock" :refreshOnCreate="false" link
			>
				<template slot="responsibles" slot-scope="scope">
					<span> {{ (scope.item && scope.item.responsibles && scope.item.responsibles.length) ? scope.item.responsibles.length : 0}} </span>
				</template> 
				<template slot="actions" slot-scope="scope">
					<z-icon-button v-bind:icon="['fa', 'dolly']" rounded v-on:click.stop.prevent="toTraking($event, scope.item.id)"></z-icon-button>
					<z-icon-button v-bind:icon="['fa', 'user']"  rounded v-on:click.stop.prevent="toWorkers(scope.item.id)"></z-icon-button>
                    <z-icon-button v-bind:icon="['fa', 'trash']" rounded v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light></z-icon-button>
                </template>
			</sort-table>
		</md-content>
    </div>
</template>

<script>
	import SortTable from "@/components/SortTable";
	import ZIconButton from '@/components/ZIconButton';
	export default {
		components: { SortTable, ZIconButton },
		data() {
			return {
				tableColumns: [
					{ label: 'Название', field: 'name', sortable: true },
					{ label: 'Описание', field: 'description', sortable: true },
					{ label: 'Ответственные', field: 'responsibles', sortable: true},
					{ label: 'Грузы', field: 'freight_count', sortable: true },
					{ label: '', field: 'actions' },
				],
				title: 'Склады',
				removeDialog: false,
				stockIdToDelete: null,
				perPage: 50
			}
		},
		computed: {
			/**
			 * Пользователь
			 */
			user() {
				return this.$store.state.users.current;
			},
			/**
			 * Список id складов к которым относится пользователь
			 */
			usersStocks() {
				return (this.user && this.user.stocks_id) ? this.user.stocks_id : [] 
			},
			/**
			 * Проверка пользователей
			 */
			isUserAgent() {
				return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('agent')+1) : false;
			},
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['get-stocks-list'];
			},
			/**
			 * Объект с флагами загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
			/**
			 * Список складов
			 */
			stocks() {
				if (!this.$store.state.stock.stocks || !this.$store.state.stock.stocks.length) return [];
				else {
					this.$store.state.stock.stocks.map(stock => {
						stock.routerLink = { name: 'Stock', params: {stock_id: stock.id} };
						return stock;
					});
					return this.$store.state.stock.stocks;
				}
			},
			/**
			 * Количество складов
			 */
			stocksAmount() {
				return this.$store.state.stock.stocks_amount
			}
		},
		watch: {
			'usersStocks'() {
				this.init();
			},
			'$route.name'(name) {
				if (name == 'Stocks') this.$store.commit('setTitle', 'Склады');
			}
		},
		created() {
			this.init();
		},
		methods: {
			/**
			 * Инициализация компонента
			 */
			init() {
				this.$nextTick(() => {
					this.$store.commit('setTitle', 'Склады');

					/* //Ограничение для Представителей, сейчас перенесено на БЕ
					if (this.isUserAgent) {
						let filter = {model: [['id', '=', this.usersStocks]]};
						this.getStocks(null, null, null, null, filter);
					} else this.getStocks();
					*/

					this.getStocks();
				});
			},
			/**
			 * Добавление склада
			 */
			addStock() {
				this.$router.push({ name: 'Stock', params: {stock_id: 'new'} });
			},
			toWorkers(id) {
				this.$router.push({ name: 'StockWorkers', params: {stock_id: id} });
			},
			/**
			 * Перенаправление на страницу с грузами
			 */
			toTraking(e, stock_id) {
				e.preventDefault();
				e.stopPropagation();
				this.$router.push({ name: 'DealsNew', query: { custom_filter: JSON.stringify({current_stock: stock_id})}});
			},
			/**
			 * Получение складов
			 */
			getStocks(page, count, orderBy, orderType) {
				this.$store.commit('showProgressBar', 'get-stocks-list');
				return this.$store.dispatch('stock/getStocks', {
					page: page, order_by: orderBy, order_type: orderType, count: count, filter: this.resolveQueryFilter()
				}).finally(() => this.$store.commit('hideProgressBar', 'get-stocks-list'));
			},
			/**
			 * Фильтрация
			 */
			resolveQueryFilter() {
				if (!this.$route.query || !this.$route.query.filter) return null;
				let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), result = {model: [], relation: [], condition: 'and'};

				if (filter.search) result.model = [['name', '%', filter.search], 'or' ['description', '%', filter.search]];

				return result;
			},
			/**
			 * Удаление группы клиентов
			 */
			removeStock(id) {
				if (!id) return;
				this.$store.commit('showProgressBar', 'get-stocks-list');
				this.$store.dispatch('stock/removeStock', id)
					.then(() => this.$root.$emit('refresh-table', 'stocks'))
					.finally(() => this.$store.commit('hideProgressBar', 'get-stocks-list'));
			},
			/**
			 * Модальное окно с подтверждением удаления группы
			 */
			onRemove(id) {
				this.$root.$emit(
					'z-alert', 'Вы уверены в удалении Склада', 'Действие необратимо!',
					() => this.removeStock(id)
				);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Stocks.vue?097103a4